/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  empty,
  errorResponse,
  floatval,
  intval,
  isArray,
  isString,
  prepareResponseData,
  reIndex,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";
import { isObject, toUpper } from "lodash";
import * as Yup from "yup";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// api
import studentApi from "../../api/Student";
import subjectApi from "../../api/Subject";
import termApi from "../../api/Terms";
import sessionApi from "../../api/Session";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { FaPrint } from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import FullPageLoader from "../../components/loader/FullPageLoader";
import colors from "../../config/colors";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { Form, Formik } from "formik";
import SelectField from "../../components/form/SelectField";
import EmptyListResponse from "../../components/emptyDiv/EmptyListResponse";
import TableLoading from "../../components/skeleton/TableLoading";

const printReport = () => {
  window.print();
};

const required = 'This field is requied';
const validationSchema = Yup.object().shape({
  session_id: Yup.string().required(required),
  term_id: Yup.string().required(required),
});

const initialValues = {
  session_id: "",
  term_id: ""
};

const BroadSheet = ({ ...props }) => {
  const printRef = useRef();
  const { user } = useContext(AuthContext);
  const [subjects, setSubjects] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [terms, setTerms] = useState([]);
  const [currentSessionTitle, setCurrentSessionTitle] = useState(user?.currentSessionTitle || '');
  const [currentTermTitle, setCurrentTermTitle] = useState(user?.currentTermTitle || '');
  const [broadSheetData, setBroadSheetData] = useState([]);
  const [students, setStudents] = useState([]);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { classId } = useParams();
  const toastTR = useRef(null);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (!classId) {
      navigate("/404");
    }
    getSubjects();
    getStudents();
    getBroadSheetData(user?.currentSessionId, user?.currentTermId);
    getTerms(user?.currentTermId);
    getSessions(user?.currentSessionId);
  }, []);

  // function to get all terms
  const getTerms = async (termId) => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await termApi.getTerms(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return [];
      } else {
        const data =
          !empty(response_data) && isArray(response_data.response)
            ? response_data.response
            : [];
        const reIndexed = reIndex(data, "_id");
        let termTitle = '';
        if (reIndexed[termId]) {
          termTitle = reIndexed[termId]?.title || 'N/A';
        }
        setCurrentTermTitle(termTitle);
        setTerms(data);
        return data;
      }
    } catch (error) {}
  };

  // function to get all sessions
  const getSessions = async (sessionId) => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await sessionApi.getSessions(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return [];
      } else {
        const data =
          !empty(response_data) && isArray(response_data.response)
            ? response_data.response
            : [];
        const reIndexed = reIndex(data, "_id");
        let sessionTitle = '';
        if (reIndexed[sessionId]) {
          sessionTitle = reIndexed[sessionId]?.title || 'N/A';
        }
        setCurrentSessionTitle(sessionTitle);
        setSessions(data);
        return data;
      }
    } catch (error) {}
  };

  // get subjects in class
  const getSubjects = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await subjectApi.getSubjectsInClass(schoolId, classId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setSubjects([]);
      }

      const data =
        !empty(response_data) &&
        !empty(response_data.response) &&
        isArray(response_data.response)
          ? response_data.response
          : [];
      setSubjects(data);
      return data;
      
    } catch (error) {
      return [];
    }
  };

  const getStudents = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudentsInClass(schoolId, null, null, null, classId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return []
      }

      const data = isArray(response_data.response) ? response_data.response : [];
      setStudents(data);
      return data;
    } catch (error) {
      return [];
    }
  }

  /**
   * Get Broad Sheet Data
   * @param {*} selectedSessionId 
   * @param {*} selectedTermId 
   */
  const getBroadSheetData = async (selectedSessionId = '', selectedTermId = '') => {
    setIsLoading(true);
    try {
      let classStudents = [];
      let classSubjects = [];
      if (empty(students)) {
        classStudents = await getStudents();
      } else {
        classStudents = students;
      }

      if (empty(subjects)) {
        classSubjects = await getSubjects();
      } else {
        classSubjects = subjects;
      }

      if (isArray(classStudents) && isArray(classSubjects)) {
        let broadSheet = [];
        classSubjects.forEach((subject) => {
          // iterate students 
          let subjectData = {}; 
          let isDataAvailable = false;
          if (subject?.title && subject?._id) {
            subjectData = { title: subject.title, assessments: [] };
            const subjectId = subject._id;
            for (let i = 0; i < classStudents.length; i++) {
              const student = isObject(classStudents[i]) ? classStudents[i] : {}; 
              const assessments = isArray(student?.assessment) ? student.assessment : [];

              const selectedAssessments = [];
              assessments.forEach(data => {
                if (data?.sessionId === selectedSessionId && data?.termId === selectedTermId && data?.subjectId === subjectId) {
                  selectedAssessments.push(data);
                }
              })

              if (!empty(selectedAssessments)) {
                isDataAvailable = true;
                const studentData = {
                  fullName: student?.fullName || '',
                  assessments: selectedAssessments
                }
  
                subjectData.assessments.push(studentData);
              }
            }

            if (isDataAvailable) {
              broadSheet.push(subjectData);
            }
          }
        })
        setBroadSheetData(broadSheet);
      }
      
    } catch (error) {
      responseDialog("error", "Error Alert", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (empty(values)) {
        return responseDialog("error", "Something went wrong.", "Please refresh or try again later.");
      }
      const sessionId = values?.session_id || "";
      const termId = values?.term_id || "";

      // get current session title
      const reIndexedSession = reIndex(sessions, "_id");
      let sessionTitle = '';
      if (reIndexedSession[sessionId]) {
        sessionTitle = reIndexedSession[sessionId]?.title || 'N/A';
      }
      setCurrentSessionTitle(sessionTitle);

      // get current term title 
      const reIndexedTerm = reIndex(terms, "_id");
      let termTitle = '';
      if (reIndexedTerm[termId]) {
        termTitle = reIndexedTerm[termId]?.title || 'N/A';
      }
      setCurrentTermTitle(termTitle);

      await getBroadSheetData(sessionId, termId);
      
      
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectInputChange = (setFieldValue, fieldName) => (e) => {
    const { value } = e.target;
    setFieldValue(fieldName, isString(value) ? value : '');
  };

  const scoreTemplate = (value) => {
    let color = '#000000';

    if (intval(value) < 50) {
      color = 'red';
    }

    return <span style={{ color }}>{value}</span>
  }

  const gradeTemplate = (value) => {
    let color = '#000000';


    if (value?.toLowerCase().includes('f') || value?.toLowerCase().includes('e')) {
      color = 'red';
    }

    return <span style={{ color }}>{value}</span>
  }

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Exam Broadsheet" />
          <div className="mb-40">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, setFieldValue }) => (
                <Form style={{ width: "100%" }}>
                  <div className="app_input_group">
                    <SelectField
                      labelTitle="Session"
                      placeholder="Select Session"
                      name="session_id"
                      options={sessions}
                      required={true}
                      height={50}
                      valueKey="id"
                      containerWidth={250}
                      selectedOption={values.session_id}
                      handleChangeFunc={handleSelectInputChange(setFieldValue, 'session_id')}
                    />
                    <SelectField
                      labelTitle="Term"
                      placeholder="Select Term"
                      name="term_id"
                      options={terms}
                      height={50}
                      required={true}
                      valueKey="id"
                      containerWidth={250}
                      selectedOption={values.term_id}
                      handleChangeFunc={handleSelectInputChange(setFieldValue, 'term_id')}
                    />
                    <ButtonIcon
                      height={45}
                      marginTop={5}
                      color="#ffffff"
                      backgroundColor="#633ccd"
                      width={160}
                      borderColor="#633ccd"
                      buttonText="Submit"
                      type="submit"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="report-sheet-contents-display">
            {!isLoading ? (
              <>
                <ButtonIcon
                  buttonText="Print"
                  icon={<FaPrint />}
                  marginTop={3}
                  iconMarginRight={8}
                  backgroundColor="transparent"
                  color={colors.primary}
                  borderColor={colors.primary}
                  height={30}
                  width={150}
                  onClick={() => printReport()}
                />
                <div className="transcript-container-script broad-sheet mt-20">
                  <div
                    className="transcript-display-script"
                    ref={printRef}
                    // style={{
                    //   backgroundImage: `url(${user.avatar})`,
                    //   backgroundSize: "400px 400px",
                    //   backgroundPosition: "center",
                    //   backgroundRepeat: "repeat",
                    // }}
                  >
                    <div className="report-header">
                      <div style={{ width: 100, height: 100 }}>
                        <img
                          src={
                            !empty(user) && !empty(user.avatar)
                              ? user.avatar
                              : ""
                          }
                          alt="non"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>
                      <div>
                        <div className="report-title">
                          {!empty(user) && !empty(user.name) ? user.name : "NA"}
                        </div>
                        <div className="report-subtitle">
                          {!empty(user) && !empty(user.address)
                            ? user.address
                            : "NA"}
                        </div>
                        <div className="report-subtitle fs-14">
                          {`TEL.: ${
                            !empty(user) && !empty(user.phoneNumber1)
                              ? user.phoneNumber1 + " ,"
                              : ""
                          }${
                            !empty(user) && !empty(user.phoneNumber2)
                              ? user.phoneNumber2 + " ,"
                              : ""
                          }${
                            !empty(user) && !empty(user.ownerPhone)
                              ? user.ownerPhone
                              : ""
                          }`}
                        </div>
                        <div className="report-subtitle fs-14 mb-10">
                          {`Email: ${
                            !empty(user) && !empty(user.email)
                              ? user.email
                              : "---"
                          }`}
                        </div>
                      </div>
                      <div style={{ width: 100, height: 100 }}>
                        <img
                          src={
                            !empty(user) && !empty(user.avatar)
                              ? user.avatar
                              : ""
                          }
                          alt="none"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="transcript-student-data mt-30 mb-30">
                        <div className="transcript-student-details">
                          <div className="mt-5">
                            <strong>Session: </strong>{" "}
                            {currentSessionTitle}
                          </div>
                          <div className="mt-5">
                            <strong>Term: </strong>{" "}
                            {currentTermTitle}
                          </div>
                        </div>
                      </div>
                      {/* end menu header */}
                      {!isLoading ? (
                        <div style={{ width: "100%", marginTop: 10 }}>
                          <div>
                            {isArray(broadSheetData) && !empty(broadSheetData) ? (
                                broadSheetData.map((broadSheet, xindex) => {
                                  return (
                                    <div key={xindex}>
                                    <>
                                      <div>
                                        {/* Display the term row */}
                                        <p
                                          style={{
                                            marginTop: 10,
                                            marginBottom: 10,
                                            width: 500,
                                            textAlign: "left",
                                          }}
                                        >
                                          <strong>{`${broadSheet?.title || ''}`}:</strong>
                                        </p>
                                        <table className="transcript-box mb-50">
                                          <thead>
                                            <tr>
                                              <th>Subject</th>
                                              {
                                                Array.from({ length: user?.noOfCAs || 2 }, (_, idx) => (
                                                  <th key={idx}>CA{idx + 1}</th>
                                                ))
                                              }
                                              <th>Exam</th>
                                              <th>Total</th>
                                              <th>Position</th>
                                              <th>Grade</th>
                                              <th>Remarks</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              {/* Loop through each assessment in the term */}
                                            {!empty(broadSheet) &&
                                            isObject(broadSheet) &&
                                            !empty(broadSheet.assessments) &&
                                            isArray(broadSheet.assessments)
                                                ? broadSheet.assessments.map((assessment, index) => {
                                                if (!empty(assessment) && isObject(assessment)) {
                                                  const studentFullName = assessment?.fullName || '--';
                                                  const studentAssessments = isArray(assessment?.assessments) ? assessment.assessments : [];

                                                  return studentAssessments.map((data, idx) => {
                                                    const ca1 = floatval(data?.ca1) || 0;
                                                    const ca2 = floatval(data?.ca2) || 0;
                                                    const ca3 = floatval(data?.ca3) || 0;
                                                    const exam = data?.exam || 0;
                                                    const total = data?.total || floatval(ca1 + ca2 + ca3 + exam);
                                                    const grade = data.grade || "---";
                                                    const remark = data.remark || "---";
                                                    const position = data.position || "---";

                                                    return (
                                                      <tr key={idx} className="fs-14">
                                                        <td className="fs-14">
                                                          {studentFullName}
                                                        </td>
                                                        {
                                                          Array.from({ length: user?.noOfCAs || 2 }, (_, idx) => (
                                                            <td key={idx}>{data?.[`ca${idx + 1}`]}</td>
                                                          ))
                                                        }
                                                        <td>{exam}</td>
                                                        <td>{scoreTemplate(total)}</td>
                                                        <td>{position}</td>
                                                        <td>{gradeTemplate(grade)}</td>
                                                        <td>
                                                          {toUpper(
                                                            remark
                                                          )}
                                                        </td>
                                                      </tr>
                                                    );
                                                  })
                                                }
                                                return null;
                                              })
                                              : 
                                              <div>---</div>
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                    </>
                                  </div>
                                );
                              })
                            ) : 
                              <EmptyListResponse message="Sorry, there are no assessment record(s) for the selected period." />
                            }
                          </div>
                        </div>
                      ) : (
                        <TableLoading />
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : <EmptyListResponse />}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
        {isLoading && <FullPageLoader visible={isLoading} />}
      </AppWrapper>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default BroadSheet;
